import { render, staticRenderFns } from "./OverviewDashboard.vue?vue&type=template&id=ada2eb62"
import script from "./OverviewDashboard.vue?vue&type=script&lang=js"
export * from "./OverviewDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports